// Simple mode (§11.19): the mode switch (remembered in localStorage; Simple the first time the app opens)
// and per-photo bookkeeping for the cleaners (what each toggle changed, so tapping again removes exactly
// that) and the chosen filter (its base settings and strength).
import { create } from 'zustand';
import type { Settings } from '../model/types';

const KEY = 'epb.mode';
function loadMode(): 'simple' | 'pro' {
  try {
    const v = globalThis.localStorage?.getItem(KEY);
    if (v === 'pro' || v === 'simple') return v;
  } catch {
    /* storage unavailable: default */
  }
  return 'simple';
}

export type CleanerRecord = { before: Record<string, unknown>; after: Record<string, unknown> };
export type FilterRecord = { id: string; base: Settings; strength: number; applied: Settings };

type SimpleState = {
  mode: 'simple' | 'pro';
  cleaners: Record<string, Record<string, CleanerRecord>>; // photo id → cleaner id → record
  filter: Record<string, FilterRecord | undefined>; // photo id → filter
  message: string | null;
  setMode: (m: 'simple' | 'pro') => void;
  set: (p: Partial<Omit<SimpleState, 'set' | 'setMode'>>) => void;
};

export const useSimple = create<SimpleState>((set) => ({
  mode: loadMode(),
  cleaners: {},
  filter: {},
  message: null,
  setMode: (mode) => {
    try {
      globalThis.localStorage?.setItem(KEY, mode);
    } catch {
      /* not remembered */
    }
    set({ mode });
  },
  set: (p) => set(p),
}));
